import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["messagesContainer", "form", "input", "submitButton"]
  static values = { ventusSvg: String }

  connect() {
    console.log("conected")
    debugger
    const chatSessionId = this.element.dataset.chatSessionId
    this.subscription = consumer.subscriptions.create(
      { channel: "ChatChannel", chat_session_id: chatSessionId },
      {
        received: (data) => {

          const container = this.messagesContainerTarget;
          const lastMessage = container.lastElementChild;

          lastMessage.outerHTML = data.html;
          
          // 6. Enable the form and clear input
          this.enableForm()

          // Scroll to the latest message
          this.scrollToBottom()
        }
      }
    )
    this.scrollToBottom() // Initial scroll on connect
  }

  async sendRequest(event) {
    event.preventDefault()

    const content = this.inputTarget.value.trim()
    if (content === "") return

    this.disableForm()
    this.addUserMessage(content)
    this.addProcessingMessage()

    const url = this.formTarget.action

    const bodyData = {
      chat_message: {
        content: content // O valor do campo de input
      }
    }

    try {
      await post(url, { body: bodyData })
      
    } catch (error) {
      this.enableForm() // Reativa o formulário em caso de falha imediata
    }
  }

  scrollToBottom() {
    this.messagesContainerTarget.scrollTop = this.messagesContainerTarget.scrollHeight
  }

  disableForm() {
    this.inputTarget.disabled = true
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = 'Sending...'
  }

  enableForm() {
    this.inputTarget.value = '' // Clear the input field
    this.inputTarget.disabled = false
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.textContent = 'Send'
    // Remove the temporary 'Processing...' message
    const processingMessage = this.messagesContainerTarget.querySelector('.processing-message')
    if (processingMessage) {
      processingMessage.remove()
    }
  }

  addUserMessage(content) {
    // Mimic the user message structure from your ERB partial
    const html = `
      <div class="max-w-4xl mx-auto">
        <div class="flex items-start gap-3 mb-4">
          <div
            class="
              bg-white rounded-2xl border border-gray-100 px-4 py-3 max-w-[80%] ml-auto
              text-emerald-950
            "
          >
            <p>${content}</p>
          </div>
        </div>
      </div>`
    this.messagesContainerTarget.insertAdjacentHTML('beforeend', html)
    this.scrollToBottom()
  }

  addProcessingMessage() {
    // Temporary message that will be removed when the real response comes in
    const html = `
      <div class="max-w-4xl mx-auto processing-message">
        <div class="flex-col items-start gap-3 mb-4 mr-2">
          <div class=" p-1 h-10 w-10 flex place-items-center ">
            <img class="h-10 mr-2 filter grayscale hover:grayscale-0" src="${this.ventusSvgValue}"> 
            VENTUS
          </div>
          <div
            class="
              bg-gray-100 rounded-2xl border border-gray-200 px-4 py-3 max-w-[80%]
            "
          >
            <p><em>Processing...</em></p>
          </div>
        </div>
      </div>`
    this.messagesContainerTarget.insertAdjacentHTML('beforeend', html)
    this.scrollToBottom()
  }
}
